module.exports = __webpack_public_path__ + "static/media/UGoing_Logo_w.71cf3bb6.png";